module.exports = __webpack_public_path__ + "static/media/partner_w_gradient.3141279a.jpg";